import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Link2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchLinkedChats, GROUP_OPS_STR as S, type LinkedChatRow } from './groupOpsApi'

/**
 * A4.11 — Bog'langan chatlar (kanal ↔ muhokama guruhi). REAL:
 * `/admin/group-ops/linked` — community_groups asosida bir jamoadagi
 * kanal↔guruh bog'lanishlari.
 */
export function GroupLinkedChats() {
  const columns = useMemo<AdminColumn<LinkedChatRow>[]>(
    () => [
      {
        key: 'channel_title',
        header: S.channel,
        type: 'text',
        minWidth: 200,
        render: (r) => (
          <Link to={`/groups/${r.channel_id}`} className="text-accent hover:underline">
            {r.channel_title || `#${r.channel_id}`}
          </Link>
        ),
      },
      {
        key: 'linked_group_title',
        header: S.linkedGroup,
        type: 'text',
        minWidth: 200,
        render: (r) => (
          <Link to={`/groups/${r.linked_group_id}`} className="text-accent hover:underline">
            {r.linked_group_title || `#${r.linked_group_id}`}
          </Link>
        ),
      },
      { key: 'member_count', header: S.members, type: 'number', width: 120, align: 'right' },
    ],
    [],
  )
  const fetcher = useCallback(fetchLinkedChats, [])
  return (
    <>
      <PageHeader title={S.linkedChats} screenId="A4.11" description={S.linkedChatsNote} />
      <DataTable<LinkedChatRow>
        screenId="A4.11"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Link2 size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
